import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { getPlaylistMetadataAsync } from '../../../general/js/api/endeavor/services/vod-service';
import TinyCarousel from '../../tiny-carousel/js/tiny-carousel';
import EndeavorPlaylistTile from './endeavor-playlist-tile';

const EndeavorPlaylist = ({ content }) => {
    const { playlistId, title, theme } = content;
    const [endeavorMetadata, setEndeavorMetadata] = useState({ isEmpty: true });

    const controlsRef = useRef(null);
    const prevRef = useRef(null);
    const nextRef = useRef(null);

    const playlistTitle = title || endeavorMetadata.title;
    const themeModifier = theme ?
        theme
            .trim()
            .toLowerCase()
            .replace(/^endeavor-playlist--/, '')
            .replace(/^--/, '')
            .replace(/\s+/g, '-') :
        '';
    const componentClassName = classNames(
        'endeavor-playlist',
        themeModifier && `endeavor-playlist--${themeModifier}`
    );

    const carouselOptions = {
        loop: false,
        nav: true,
        navPosition: 'bottom',
        controls: true,
        mouseDrag: true,
        touch: true,
        items: 1,
        gutter: 20,
        edgePadding: 20,

        responsive: {
            480: { items: 1, edgePadding: 20, gutter: 20 },
            640: { items: 2, edgePadding: 30, gutter: 20 },
            900: { items: 3, edgePadding: 0, slideBy: 3 },
            1200: { items: 3, edgePadding: 0, slideBy: 3 }
        },
        controlsContainer: controlsRef.current,
        prevButton: prevRef.current,
        nextButton: nextRef.current
    };

    useEffect(() => {
        getPlaylistMetadataAsync({ playlistId }).then((response) => {
            setEndeavorMetadata(response.metadata);
        });
    }, [playlistId]);

    return (
        <div className={componentClassName}>
            <div className="endeavor-playlist__header">
                {playlistTitle && (
                    <h2 className="endeavor-playlist__title">{playlistTitle}</h2>
                )}

                <div className="endeavor-playlist__controls" ref={controlsRef}>
                    <button className="carousel-controls__prev-btn endeavor-playlist__prev" ref={prevRef}>
                        <span className="button-content">
                            <svg width="16" height="10">
                                <use xlinkHref="#icon-chevron-left"></use>
                            </svg>
                        </span>
                    </button>

                    <button className="carousel-controls__next-btn endeavor-playlist__next" ref={nextRef}>
                        <span className="button-content">
                            <svg width="16" height="10">
                                <use xlinkHref="#icon-chevron-right"></use>
                            </svg>
                        </span>
                    </button>
                </div>
            </div>

            {Array.isArray(endeavorMetadata.vods) && endeavorMetadata.vods.length > 0 && (
                <div className="endeavor-playlist__carousel">
                    <TinyCarousel
                        slides={endeavorMetadata.vods}
                        options={carouselOptions}
                    >
                        {endeavorMetadata.vods.map((vod) => (
                            <div className="endeavor-playlist__carousel-slide" key={vod.id}>
                                <EndeavorPlaylistTile vod={vod} />
                            </div>
                        ))}
                    </TinyCarousel>
                </div>
            )}
        </div>
    );
};

export default EndeavorPlaylist;
